module.exports = __webpack_public_path__ + "img/reset-icon.f9574c73.svg";